/* eslint-disable max-len */
import React from 'react'
import PropTypes from 'prop-types'

import { SvgIcon } from '../svg-icon'

import styles from './speeding-position-icon.module.css'

const propTypes = {
    eventSeverity: PropTypes.string
}

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48,
    eventSeverity: 'default'
}

/**
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <...Icon width={12} />
 */
const SpeedingPositionIcon = props => {
    const { eventSeverity } = props
    return (
        <SvgIcon {...props} className={styles['speeding-position-pin']}>
            <g>
                <path
                    className={styles['icon-foreground']}
                    d={`M37.528,8.45c-3.459-3.435-8.236-5.561-13.511-5.561c-5.278,0-10.056,2.126-13.514,5.564
            c-3.459,3.436-5.598,8.185-5.598,13.43c0,5.246,2.144,9.996,5.603,13.434c3.459,3.437,13.509,11.257,13.509,11.257
            S34.07,38.751,37.53,35.314c3.459-3.439,5.598-8.186,5.598-13.431C43.128,16.637,40.988,11.888,37.528,8.45`}
                />
                <path
                    className={styles[eventSeverity]}
                    d={`M36.627,9.385c-3.228-3.206-7.686-5.19-12.611-5.19c-4.926,0-9.386,1.985-12.613,5.192
            c-3.228,3.207-5.225,7.64-5.225,12.535c0,4.896,2.001,9.33,5.23,12.539c3.228,3.207,12.608,10.506,12.608,10.506
            s9.384-7.301,12.613-10.51c3.228-3.21,5.225-7.64,5.225-12.535C41.854,17.027,39.857,12.594,36.627,9.385`}
                />
                <g>
                    <g>
                        <g>
                            <path
                                className={styles['icon-foreground']}
                                d={`M23.422,15.752c1.726,0.174,4.195,1.079,6.115,2.201l3.231-2.577c-0.958-0.675-2.029-1.318-3.28-1.787
                        c-0.026-0.009-0.052-0.019-0.078-0.028c-0.167-0.062-0.335-0.122-0.506-0.178c-0.085-0.028-0.171-0.055-0.258-0.083
                        c-0.113-0.035-0.226-0.069-0.34-0.103c-0.141-0.041-0.284-0.079-0.427-0.117c-0.064-0.016-0.128-0.033-0.19-0.049
                        c-0.189-0.046-0.378-0.089-0.567-0.129c-0.026-0.006-0.054-0.011-0.08-0.016c-0.218-0.045-0.436-0.084-0.657-0.12
                        c-0.007,0-0.015-0.002-0.023-0.003c-0.225-0.035-0.452-0.066-0.679-0.093c-0.008-0.001-0.016-0.003-0.016-0.003
                        c-0.014-0.002-0.021-0.002-0.028-0.002c-0.206-0.024-0.414-0.042-0.623-0.058c-0.045-0.003-0.09-0.007-0.135-0.011
                        c-0.165-0.011-0.332-0.019-0.497-0.024c-0.094-0.003-0.19-0.007-0.284-0.009c-0.113-0.002-0.226-0.002-0.339-0.002
                        c-0.148,0-0.296,0.001-0.443,0.005c-0.063,0.002-0.128,0.004-0.192,0.007c-0.19,0.007-0.38,0.017-0.569,0.031
                        c-0.014,0.001-0.028,0.001-0.042,0.003c-0.019,0.001-0.038,0.004-0.056,0.005c-0.211,0.017-0.42,0.037-0.628,0.063
                        c-0.026,0.003-0.052,0.006-0.078,0.01c-0.204,0.025-0.406,0.054-0.608,0.086c-0.045,0.008-0.088,0.015-0.132,0.023
                        c-0.174,0.03-0.348,0.062-0.521,0.097c-0.082,0.016-0.162,0.034-0.244,0.052c-0.129,0.028-0.255,0.058-0.383,0.089
                        c-0.131,0.032-0.261,0.066-0.391,0.102c-0.073,0.02-0.145,0.04-0.217,0.061c-0.186,0.054-0.371,0.111-0.554,0.172
                        c-0.013,0.004-0.026,0.009-0.04,0.012c-2.302,0.764-4.357,2.036-5.982,3.742c-0.093,0.097-0.134,0.217-0.13,0.335
                        c-0.003,0.107,0.032,0.215,0.108,0.307c0.186,0.223,0.524,0.246,0.779,0.082C15.96,16.232,19.788,15.386,23.422,15.752z`}
                            />
                        </g>
                        <path
                            className={styles['icon-foreground']}
                            d={`M22.781,21.07l-0.442-0.151c0.846,0.263,1.641,0.6,2.38,1.074l2.671-2.446
                    c-0.409-0.242-0.83-0.463-1.269-0.65c-0.021-0.009-0.042-0.017-0.063-0.027c-0.135-0.056-0.271-0.112-0.409-0.164
                    c-0.07-0.027-0.139-0.052-0.209-0.076c-0.091-0.033-0.183-0.065-0.275-0.095c-0.115-0.038-0.231-0.074-0.346-0.108
                    c-0.052-0.015-0.103-0.03-0.155-0.045c-0.152-0.043-0.305-0.082-0.459-0.118c-0.021-0.006-0.042-0.011-0.065-0.016
                    c-0.176-0.041-0.353-0.077-0.531-0.11c-0.007-0.001-0.013-0.003-0.02-0.005c-0.182-0.032-0.366-0.061-0.55-0.085
                    c-0.006-0.001-0.013-0.003-0.02-0.003c-0.005,0-0.011,0-0.015-0.001c-0.167-0.021-0.336-0.039-0.505-0.054
                    c-0.036-0.003-0.072-0.006-0.11-0.009c-0.134-0.011-0.268-0.018-0.403-0.024c-0.075-0.003-0.153-0.007-0.23-0.008
                    c-0.091-0.002-0.183-0.002-0.274-0.002c-0.12,0-0.239,0.001-0.359,0.005c-0.052,0.001-0.105,0.004-0.156,0.006
                    c-0.154,0.007-0.308,0.016-0.462,0.03c-0.011,0.001-0.022,0.001-0.034,0.002c-0.016,0.002-0.03,0.005-0.046,0.005
                    c-0.171,0.016-0.34,0.034-0.508,0.058c-0.022,0.002-0.043,0.006-0.064,0.009c-0.165,0.024-0.33,0.05-0.493,0.08
                    c-0.035,0.006-0.072,0.014-0.107,0.021c-0.141,0.028-0.282,0.056-0.422,0.09c-0.066,0.015-0.131,0.031-0.197,0.048
                    c-0.104,0.026-0.208,0.054-0.312,0.082c-0.106,0.03-0.211,0.062-0.317,0.095c-0.058,0.019-0.117,0.037-0.176,0.056
                    c-0.151,0.049-0.3,0.102-0.449,0.158c-0.011,0.004-0.021,0.008-0.032,0.012l-0.049,0.016c-0.814,0.301-1.59,0.702-2.314,1.198
                    c-0.32,0.218-0.629,0.455-0.926,0.71c-0.086,0.074-0.134,0.177-0.145,0.284c-0.016,0.097-0.001,0.201,0.049,0.298
                    c0.121,0.233,0.4,0.334,0.623,0.226C17.113,20.2,20.022,20.07,22.781,21.07z`}
                        />
                        <path
                            className={styles['icon-foreground']}
                            d={`M35.386,18.228c-0.025-0.037-0.054-0.07-0.086-0.1c-0.011-0.01-0.021-0.018-0.033-0.026
                    c-0.023-0.019-0.046-0.035-0.071-0.049c-0.014-0.008-0.027-0.015-0.042-0.022c-0.026-0.012-0.051-0.021-0.078-0.029
                    c-0.014-0.005-0.027-0.009-0.042-0.012c-0.04-0.009-0.08-0.014-0.12-0.014l-0.004,0l-0.01,0.001
                    c-0.045,0.001-0.089,0.009-0.132,0.02c-0.014,0.003-0.026,0.007-0.04,0.011c-0.047,0.016-0.094,0.035-0.136,0.065l-9.361,6.985
                    c-0.586-0.218-1.217-0.343-1.878-0.343c-2.978,0-5.391,2.414-5.391,5.391c0,2.978,2.413,5.392,5.391,5.392
                    c2.978,0,5.391-2.414,5.391-5.391c0-0.548-0.083-1.076-0.235-1.573l6.847-9.621c0.019-0.025,0.035-0.049,0.049-0.076
                    C35.513,18.651,35.513,18.415,35.386,18.228z`}
                        />
                    </g>
                </g>
            </g>
        </SvgIcon>
    )
}

SpeedingPositionIcon.defaultProps = defaultProps
SpeedingPositionIcon.propTypes = propTypes

export { SpeedingPositionIcon }
